var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarBgSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 186,
    viewBox: "0 0 186 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.61,
    y: 62.7489,
    width: 81,
    height: 81,
    rx: 9.5,
    transform: "rotate(45 116.61 62.7489)",
    stroke: "#F2F2FC",
    strokeWidth: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.8904,
    y: 70.0033,
    width: 44,
    height: 44,
    rx: 9.5,
    transform: "rotate(-135 68.8904 70.0033)",
    stroke: "#F2F2FC",
    strokeWidth: 11
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBgSmall);
export default __webpack_public_path__ + "static/media/sidebar_bg_small.3a77431b988dc0df80a0d81d198f656e.svg";
export { ForwardRef as ReactComponent };